// // coinley-sdk/src/services/coinleyConnectClient.js

// /**
//  * Coinley Connect Client SDK
//  * Handles external wallet connections through Coinley Connect service
//  */
// class CoinleyConnectClient {
//     constructor(options = {}) {
//         this.apiUrl = options.apiUrl || 'http://localhost:3001/api';
//         this.walletInterfaceUrl = options.walletInterfaceUrl || 'http://localhost:3001';
//         this.debug = options.debug || false;
        
//         this.log('Coinley Connect Client initialized', { apiUrl: this.apiUrl });
//     }
    
//     /**
//      * Get supported wallets for a specific network
//      */
//     async getSupportedWallets(network = null) {
//         try {
//             const url = network ? 
//                 `${this.apiUrl}/wallets/supported?network=${network}` : 
//                 `${this.apiUrl}/wallets/supported`;
                
//             const response = await fetch(url);
//             const data = await response.json();
            
//             if (!data.success) {
//                 throw new Error(data.error || 'Failed to get supported wallets');
//             }
            
//             return data.wallets;
//         } catch (error) {
//             this.log('Error getting supported wallets:', error);
//             throw error;
//         }
//     }
    
//     /**
//      * Initiate wallet connection
//      */
//     async connectWallet(walletType, network, options = {}) {
//         try {
//             this.log('Initiating wallet connection', { walletType, network });
            
//             const response = await fetch(`${this.apiUrl}/connections/connect`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({
//                     walletType,
//                     network,
//                     returnUrl: options.returnUrl,
//                     metadata: options.metadata || {}
//                 })
//             });
            
//             const data = await response.json();
            
//             if (!data.success) {
//                 throw new Error(data.error || 'Failed to initiate connection');
//             }
            
//             // Build interface URL
//             const interfaceUrl = this.buildInterfaceUrl(data.sessionId, walletType, network, options.transaction);
            
//             // Open wallet interface based on options
//             if (options.openInNewTab) {
//                 window.open(interfaceUrl, '_blank');
//             } else if (options.popup) {
//                 this.openPopup(interfaceUrl, options.popup);
//             } else if (options.iframe) {
//                 this.openIframe(interfaceUrl, options.iframe);
//             } else {
//                 // Default: open in popup
//                 this.openPopup(interfaceUrl, { width: 420, height: 650 });
//             }
            
//             return {
//                 sessionId: data.sessionId,
//                 interfaceUrl,
//                 statusUrl: `${this.apiUrl}/connections/status/${data.sessionId}`
//             };
            
//         } catch (error) {
//             this.log('Error initiating wallet connection:', error);
//             throw error;
//         }
//     }
    
//     /**
//      * Check connection status
//      */
//     async getConnectionStatus(sessionId) {
//         try {
//             const response = await fetch(`${this.apiUrl}/connections/status/${sessionId}`);
//             const data = await response.json();
            
//             if (!data.success) {
//                 throw new Error(data.error || 'Failed to get connection status');
//             }
            
//             return data.session;
//         } catch (error) {
//             this.log('Error getting connection status:', error);
//             throw error;
//         }
//     }
    
//     /**
//      * Poll connection status until connected or failed
//      */
//     async waitForConnection(sessionId, timeout = 300000) { // 5 minutes default
//         return new Promise((resolve, reject) => {
//             const startTime = Date.now();
            
//             const checkStatus = async () => {
//                 try {
//                     const status = await this.getConnectionStatus(sessionId);
                    
//                     if (status.status === 'connected') {
//                         resolve(status);
//                         return;
//                     }
                    
//                     if (status.status === 'failed' || status.status === 'expired') {
//                         reject(new Error(status.error || `Connection ${status.status}`));
//                         return;
//                     }
                    
//                     // Check timeout
//                     if (Date.now() - startTime > timeout) {
//                         reject(new Error('Connection timeout'));
//                         return;
//                     }
                    
//                     // Continue polling
//                     setTimeout(checkStatus, 2000);
                    
//                 } catch (error) {
//                     reject(error);
//                 }
//             };
            
//             checkStatus();
//         });
//     }
    
//     /**
//      * Send transaction through connected wallet
//      */
//     async sendTransaction(sessionId, transactionData) {
//         try {
//             this.log('Sending transaction', { sessionId, transactionData });
            
//             const response = await fetch(`${this.apiUrl}/transactions/send`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({
//                     sessionId,
//                     ...transactionData
//                 })
//             });
            
//             const data = await response.json();
            
//             if (!data.success) {
//                 throw new Error(data.error || 'Failed to send transaction');
//             }
            
//             return data;
//         } catch (error) {
//             this.log('Error sending transaction:', error);
//             throw error;
//         }
//     }
    
//     /**
//      * Disconnect wallet
//      */
//     async disconnectWallet(sessionId) {
//         try {
//             const response = await fetch(`${this.apiUrl}/connections/disconnect`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({ sessionId })
//             });
            
//             const data = await response.json();
            
//             if (!data.success) {
//                 throw new Error(data.error || 'Failed to disconnect wallet');
//             }
            
//             return data;
//         } catch (error) {
//             this.log('Error disconnecting wallet:', error);
//             throw error;
//         }
//     }
    
//     /**
//      * Build wallet interface URL
//      */
//     buildInterfaceUrl(sessionId, walletType, network, transaction = null) {
//         const params = new URLSearchParams({
//             sessionId,
//             walletType,
//             network
//         });
        
//         if (transaction) {
//             Object.entries(transaction).forEach(([key, value]) => {
//                 if (value !== null && value !== undefined) {
//                     params.append(key, value.toString());
//                 }
//             });
//         }
        
//         return `${this.walletInterfaceUrl}?${params.toString()}`;
//     }
    
//     /**
//      * Open popup window for wallet connection
//      */
//     openPopup(url, options = {}) {
//         const defaultOptions = {
//             width: 420,
//             height: 650,
//             left: (screen.width - 420) / 2,
//             top: (screen.height - 650) / 2,
//             scrollbars: 'no',
//             resizable: 'no',
//             toolbar: 'no',
//             menubar: 'no',
//             location: 'no',
//             status: 'no'
//         };
        
//         const popupOptions = { ...defaultOptions, ...options };
//         const optionsString = Object.entries(popupOptions)
//             .map(([key, value]) => `${key}=${value}`)
//             .join(',');
            
//         const popup = window.open(url, 'coinley-connect', optionsString);
        
//         // Listen for messages from popup
//         const messageHandler = (event) => {
//             if (event.origin !== new URL(this.walletInterfaceUrl).origin) return;
            
//             if (event.data.type === 'wallet_connected') {
//                 this.log('Wallet connected via popup:', event.data);
//             }
            
//             if (event.data.type === 'transaction_sent') {
//                 this.log('Transaction sent via popup:', event.data);
//             }
//         };
        
//         window.addEventListener('message', messageHandler);
        
//         // Clean up event listener when popup closes
//         const checkClosed = setInterval(() => {
//             if (popup.closed) {
//                 window.removeEventListener('message', messageHandler);
//                 clearInterval(checkClosed);
//             }
//         }, 1000);
        
//         return popup;
//     }
    
//     /**
//      * Open iframe for wallet connection (embedded mode)
//      */
//     openIframe(url, options = {}) {
//         const defaultOptions = {
//             width: '420px',
//             height: '650px',
//             border: 'none',
//             borderRadius: '12px',
//             boxShadow: '0 10px 40px rgba(0,0,0,0.15)'
//         };
        
//         const iframeOptions = { ...defaultOptions, ...options };
        
//         // Create iframe
//         const iframe = document.createElement('iframe');
//         iframe.src = url;
//         iframe.style.width = iframeOptions.width;
//         iframe.style.height = iframeOptions.height;
//         iframe.style.border = iframeOptions.border;
//         iframe.style.borderRadius = iframeOptions.borderRadius;
//         iframe.style.boxShadow = iframeOptions.boxShadow;
        
//         // Create overlay
//         const overlay = document.createElement('div');
//         overlay.style.cssText = `
//             position: fixed;
//             top: 0;
//             left: 0;
//             width: 100%;
//             height: 100%;
//             background: rgba(0,0,0,0.5);
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             z-index: 10000;
//         `;
        
//         overlay.appendChild(iframe);
//         document.body.appendChild(overlay);
        
//         // Close on overlay click
//         overlay.addEventListener('click', (e) => {
//             if (e.target === overlay) {
//                 document.body.removeChild(overlay);
//             }
//         });
        
//         // Listen for messages from iframe
//         const messageHandler = (event) => {
//             if (event.origin !== new URL(this.walletInterfaceUrl).origin) return;
            
//             if (event.data.type === 'wallet_connected') {
//                 this.log('Wallet connected via iframe:', event.data);
//             }
            
//             if (event.data.type === 'transaction_sent') {
//                 this.log('Transaction sent via iframe:', event.data);
//                 // Close iframe after transaction
//                 document.body.removeChild(overlay);
//             }
//         };
        
//         window.addEventListener('message', messageHandler);
        
//         return { iframe, overlay };
//     }
    
//     /**
//      * Debug logging
//      */
//     log(message, data = null) {
//         if (this.debug) {
//             console.log(`[Coinley Connect] ${message}`, data || '');
//         }
//     }
// }

// // ✅ FIXED: Proper export
// export { CoinleyConnectClient };

// // ✅ Also export as default for flexibility
// export default CoinleyConnectClient;









// coinley-sdk/src/services/coinleyConnectClient.js - Fixed version without ethers.js dependency

// this is code page consuming api from coinley-connect


// coinley-sdk/src/services/coinleyConnectClient.js - Fixed version for wallet integration

class CoinleyConnectClient {
    constructor(options = {}) {
        this.apiUrl = options.apiUrl || 'http://localhost:3001/api';
        this.walletInterfaceUrl = options.walletInterfaceUrl || 'http://localhost:3001';
        this.debug = options.debug || false;
        
        this.log('Coinley Connect Client initialized', { apiUrl: this.apiUrl });
    }
    
    /**
     * ✅ FIXED: Enhanced wallet connection with proper popup handling
     */
    async connectWallet(walletType, network, options = {}) {
        try {
            this.log('Initiating wallet connection', { walletType, network });
            
            // First create a session on the server
            const response = await fetch(`${this.apiUrl}/connections/connect`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    walletType,
                    network,
                    returnUrl: options.returnUrl,
                    metadata: options.metadata || {}
                })
            });
            
            const data = await response.json();
            
            if (!data.success) {
                throw new Error(data.error || 'Failed to initiate connection');
            }
            
            // ✅ Build the wallet interface URL with session ID
            const interfaceUrl = `${this.walletInterfaceUrl}?sessionId=${data.sessionId}&walletType=${walletType}&network=${network}`;
            
            this.log('Opening wallet interface:', interfaceUrl);
            
            // Open the wallet interface popup
            const popup = this.openPopup(interfaceUrl, {
                width: 420,
                height: 650,
                title: `Connect ${walletType}`
            });
            
            // ✅ Listen for wallet connection messages from popup
            return new Promise((resolve, reject) => {
                const timeout = setTimeout(() => {
                    reject(new Error('Connection timeout'));
                }, 300000); // 5 minutes
                
                const messageHandler = (event) => {
                    // Verify origin for security
                    if (event.origin !== new URL(this.walletInterfaceUrl).origin) {
                        return;
                    }
                    
                    this.log('Received message from popup:', event.data);
                    
                    if (event.data.type === 'wallet_connected') {
                        clearTimeout(timeout);
                        window.removeEventListener('message', messageHandler);
                        
                        // Update the session status on the server
                        this.updateConnectionStatus(data.sessionId, {
                            status: 'connected',
                            address: event.data.address,
                            walletType: event.data.walletType
                        });
                        
                        resolve({
                            sessionId: data.sessionId,
                            address: event.data.address,
                            walletType: event.data.walletType,
                            network: network,
                            isConnected: true
                        });
                    }
                    
                    if (event.data.type === 'wallet_connection_failed') {
                        clearTimeout(timeout);
                        window.removeEventListener('message', messageHandler);
                        reject(new Error(event.data.error || 'Connection failed'));
                    }
                };
                
                window.addEventListener('message', messageHandler);
                
                // Also check if popup was closed without connection
                const checkClosed = setInterval(() => {
                    if (popup.closed) {
                        clearTimeout(timeout);
                        clearInterval(checkClosed);
                        window.removeEventListener('message', messageHandler);
                        reject(new Error('Connection cancelled - popup was closed'));
                    }
                }, 1000);
            });
            
        } catch (error) {
            this.log('Error initiating wallet connection:', error);
            throw error;
        }
    }
    
    /**
     * ✅ Update connection status on server
     */
    async updateConnectionStatus(sessionId, statusData) {
        try {
            const response = await fetch(`${this.apiUrl}/connections/update-status`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    sessionId,
                    ...statusData
                })
            });
            
            const data = await response.json();
            this.log('Connection status updated:', data);
            return data;
            
        } catch (error) {
            this.log('Error updating connection status:', error);
            throw error;
        }
    }
    
    /**
     * ✅ ENHANCED: Send transaction with better popup handling
     */
    async sendTransaction(sessionId, transactionData) {
        try {
            this.log('Sending transaction', { sessionId, transactionData });
            
            const { to, amount, currency, network } = transactionData;
            
            if (!to || !amount) {
                throw new Error('Recipient address and amount are required');
            }
            
            // First create the transaction record on server
            const response = await fetch(`${this.apiUrl}/transactions/send`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    sessionId,
                    ...transactionData
                })
            });
            
            if (!response.ok) {
                let errorData;
                try {
                    errorData = await response.json();
                } catch (e) {
                    throw new Error(`Transaction failed: ${response.status} ${response.statusText}`);
                }
                throw new Error(errorData.error || `Transaction failed: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (!data.success) {
                throw new Error(data.error || 'Failed to send transaction');
            }
            
            
            // ✅ Open transaction interface for user to confirm in wallet
            const txInterfaceUrl = `${this.walletInterfaceUrl}?sessionId=${sessionId}&action=transaction&transactionId=${data.transactionId}&to=${to}&amount=${amount}&currency=${currency}&network=${network}`;
            
            this.log('Opening transaction interface:', txInterfaceUrl);
            
            const popup = this.openPopup(txInterfaceUrl, {
                width: 420,
                height: 650,
                title: `Send Transaction`
            });
            
            // ✅ Wait for transaction completion
            return new Promise((resolve, reject) => {
                const timeout = setTimeout(() => {
                    reject(new Error('Transaction timeout'));
                }, 300000); // 5 minutes
                
                const messageHandler = (event) => {
                    if (event.origin !== new URL(this.walletInterfaceUrl).origin) {
                        return;
                    }
                    
                    this.log('Received transaction message:', event.data);
                    
                    if (event.data.type === 'transaction_sent') {
                        clearTimeout(timeout);
                        window.removeEventListener('message', messageHandler);
                        
                        // Update the transaction status on server
                        this.updateTransactionStatus(data.transactionId, {
                            hash: event.data.hash,
                            status: 'confirmed'
                        });
                        
                        resolve(event.data.hash);
                    }
                    
                    if (event.data.type === 'transaction_failed') {
                        clearTimeout(timeout);
                        window.removeEventListener('message', messageHandler);
                        reject(new Error(event.data.error || 'Transaction failed'));
                    }
                };
                
                window.addEventListener('message', messageHandler);
                
                const checkClosed = setInterval(() => {
                    if (popup.closed) {
                        clearTimeout(timeout);
                        clearInterval(checkClosed);
                        window.removeEventListener('message', messageHandler);
                        reject(new Error('Transaction cancelled'));
                    }
                }, 1000);
            });
            
        } catch (error) {
            this.log('Error sending transaction:', error);
            throw error;
        }
    }
    
    /**
     * ✅ Update transaction status on server
     */
    async updateTransactionStatus(transactionId, statusData) {
        try {
            const response = await fetch(`${this.apiUrl}/transactions/update-status`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    transactionId,
                    ...statusData
                })
            });
            
            const data = await response.json();
            this.log('Transaction status updated:', data);
            return data;
            
        } catch (error) {
            this.log('Error updating transaction status:', error);
            throw error;
        }
    }
    
    /**
     * ✅ ENHANCED: Better popup handling
     */
    openPopup(url, options = {}) {
        const defaultOptions = {
            width: 420,
            height: 650,
            left: Math.round((screen.width - 420) / 2),
            top: Math.round((screen.height - 650) / 2),
            scrollbars: 'no',
            resizable: 'no',
            toolbar: 'no',
            menubar: 'no',
            location: 'no',
            status: 'no'
        };
        
        const popupOptions = { ...defaultOptions, ...options };
        const optionsString = Object.entries(popupOptions)
            .map(([key, value]) => `${key}=${value}`)
            .join(',');
            
        const popup = window.open(url, 'coinley-connect', optionsString);
        
        if (!popup) {
            throw new Error('Popup blocked. Please allow popups for wallet connections.');
        }
        
        // Focus the popup
        popup.focus();
        
        return popup;
    }
    
    /**
     * Check connection status
     */
    async getConnectionStatus(sessionId) {
        try {
            const response = await fetch(`${this.apiUrl}/connections/status/${sessionId}`);
            const data = await response.json();
            
            if (!data.success) {
                throw new Error(data.error || 'Failed to get connection status');
            }
            
            return data.session;
        } catch (error) {
            this.log('Error getting connection status:', error);
            throw error;
        }
    }
    
    /**
     * Get supported wallets for a network
     */
    async getSupportedWallets(network = null) {
        try {
            const url = network ? 
                `${this.apiUrl}/wallets/supported?network=${network}` : 
                `${this.apiUrl}/wallets/supported`;
                
            const response = await fetch(url);
            const data = await response.json();
            
            if (!data.success) {
                throw new Error(data.error || 'Failed to get supported wallets');
            }
            
            return data.wallets;
        } catch (error) {
            this.log('Error getting supported wallets:', error);
            throw error;
        }
    }
    
    /**
     * Disconnect wallet
     */
    async disconnectWallet(sessionId) {
        try {
            const response = await fetch(`${this.apiUrl}/connections/disconnect`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ sessionId })
            });
            
            const data = await response.json();
            
            if (!data.success) {
                throw new Error(data.error || 'Failed to disconnect wallet');
            }
            
            return data;
        } catch (error) {
            this.log('Error disconnecting wallet:', error);
            throw error;
        }
    }
    
    /**
     * Debug logging
     */
    log(message, data = null) {
        if (this.debug) {
            console.log(`[Coinley Connect] ${message}`, data || '');
        }
    }
}

export { CoinleyConnectClient };
export default CoinleyConnectClient;